module.exports = __webpack_public_path__ + "static/img/image.6f0679d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/es-orange/images/image.jpg
// module id = ryBn
// module chunks = 1